import { ApplicationConfig, provideAppInitializer, provideZoneChangeDetection, inject } from '@angular/core';
import { ConfigService } from './core/services/config.service';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { gasLoggerInterceptor } from './core/services/gas-logger.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { Platform } from '@angular/cdk/platform';
import { routes } from './app.routes';
import { FrDateAdapter } from './core/adapters/fr-date-adapter';

/** Format jj/mm/aaaa */
const FR_DATE_FORMATS = {
  parse: {
    dateInput: 'dd/MM/yyyy',
  },
  display: {
    dateInput: { day: '2-digit', month: '2-digit', year: 'numeric' },
    monthYearLabel: { month: 'long', year: 'numeric' },
    dateA11yLabel: { day: '2-digit', month: 'long', year: 'numeric' },
    monthYearA11yLabel: { month: 'long', year: 'numeric' },
  },
};

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => {
      if (window.location.pathname === '/payer') return Promise.resolve();
      return inject(ConfigService).loadRemoteConfig();
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([gasLoggerInterceptor])),
    provideAnimationsAsync(),
    { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
    { provide: MAT_DATE_FORMATS, useValue: FR_DATE_FORMATS },
    { provide: DateAdapter, useClass: FrDateAdapter, deps: [MAT_DATE_LOCALE, Platform] },
  ],
};
